module.exports = __webpack_public_path__ + "img/Jarosch2021.d90e5a02.jpg";